(function () {
  'use strict';

  var data = window.tloOosData;
  if (!data) return;

  var wrap = document.getElementById('tlo-oos-notify');
  if (!wrap) return;

  var form = wrap.querySelector('.tlo-oos-notify__form');
  var emailInput = wrap.querySelector('.tlo-oos-notify__email');
  var variantInput = wrap.querySelector('.tlo-oos-notify__variant-id');
  var msgEl = wrap.querySelector('.tlo-oos-notify__msg');
  var labelEl = wrap.querySelector('.tlo-oos-notify__label');
  var submitBtn = wrap.querySelector('.tlo-oos-notify__btn');

  // Populate text from Liquid settings
  labelEl.textContent = data.messages.label;
  emailInput.setAttribute('placeholder', data.messages.placeholder);
  submitBtn.textContent = data.messages.button;

  // -- Variant helpers --

  function getVariantIdFromUrl() {
    return new URLSearchParams(window.location.search).get('variant');
  }

  function findVariant(id) {
    return data.variants.find(function (v) { return String(v.id) === String(id); });
  }

  function getDefaultVariant() {
    return data.variants.find(function (v) { return v.available; }) || data.variants[0];
  }

  // -- OOS show/hide --

  function setOosState(isOos, variantId) {
    variantInput.value = variantId || '';

    if (isOos) {
      wrap.style.display = 'block';
      wrap.removeAttribute('aria-hidden');
      document.body.classList.add('tlo-oos-active');
    } else {
      wrap.style.display = 'none';
      wrap.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('tlo-oos-active');
      resetForm();
    }
  }

  function checkVariant(variantId) {
    var variant = variantId ? findVariant(variantId) : null;
    if (!variant) variant = getDefaultVariant();
    if (!variant) return;
    setOosState(!variant.available, String(variant.id));
  }

  function resetForm() {
    emailInput.value = '';
    msgEl.style.display = 'none';
    msgEl.textContent = '';
    msgEl.className = 'tlo-oos-notify__msg';
    submitBtn.disabled = false;
    submitBtn.textContent = data.messages.button;
  }

  // -- Position: insert OOS form directly below the price element --

  function positionForm() {
    // Scope to the product info panel to avoid matching other page prices
    var panel = document.getElementById('tlo-oos-notify').closest
      ? document.querySelector('[id^="product-info-"]') || document.querySelector('.pdp-details')
      : document.body;

    var priceEl = panel ? panel.querySelector('.product-price') : null;

    if (priceEl) {
      // Only move if not already in the right place
      if (priceEl.nextElementSibling !== wrap) {
        priceEl.insertAdjacentElement('afterend', wrap);
      }
      return true;
    }
    return false;
  }

  // Re-position if React re-renders moves the element
  var positionInterval = setInterval(function () {
    if (document.querySelector('.product-price')) {
      positionForm();
    }
  }, 500);

  // Stop the position interval after 10s (React should have settled by then)
  setTimeout(function () { clearInterval(positionInterval); }, 10000);

  // -- Klaviyo company ID detection --

  function detectKlaviyoId() {
    if (data.klaviyoCompanyId) return data.klaviyoCompanyId;
    var scripts = document.querySelectorAll('script[src*="klaviyo"]');
    for (var i = 0; i < scripts.length; i++) {
      var match = scripts[i].src.match(/company_id=([^&]+)/);
      if (match) return match[1];
    }
    return null;
  }

  // -- Form submission --

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var email = emailInput.value.trim();
    if (!email || !email.includes('@')) {
      emailInput.focus();
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting…';

    var variantId = variantInput.value;
    var klaviyoId = detectKlaviyoId();

    var promises = [];

    // 1. Klaviyo Back in Stock subscribe — feeds into Klaviyo Back in Stock Flow
    if (klaviyoId && variantId) {
      promises.push(
        fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams({
            a: klaviyoId,
            email: email,
            variant: variantId,
            platform: 'shopify'
          }).toString()
        }).catch(function () { return null; })
      );
    }

    // 2. Shopify contact form — structured body so Shopify Flow can parse it
    var contactBody = new FormData();
    contactBody.append('form_type', 'contact');
    contactBody.append('utf8', '✓');
    contactBody.append('contact[email]', email);
    contactBody.append('contact[name]', 'Back in Stock Request');
    contactBody.append(
      'contact[body]',
      '[OOS_NOTIFY] Product: ' + data.productTitle +
      ' | Handle: ' + data.productHandle +
      ' | Product ID: ' + data.productId +
      ' | Variant ID: ' + variantId
    );
    promises.push(
      fetch('/contact', {
        method: 'POST',
        body: contactBody,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).catch(function () { return null; })
    );

    Promise.all(promises).then(function () {
      msgEl.textContent = data.messages.success;
      msgEl.className = 'tlo-oos-notify__msg tlo-oos-notify__msg--success';
      msgEl.style.display = 'block';
      emailInput.value = '';
      submitBtn.disabled = false;
      submitBtn.textContent = data.messages.button;
    }).catch(function () {
      msgEl.textContent = data.messages.error;
      msgEl.className = 'tlo-oos-notify__msg tlo-oos-notify__msg--error';
      msgEl.style.display = 'block';
      submitBtn.disabled = false;
      submitBtn.textContent = data.messages.button;
    });
  });

  // -- Variant change detection --

  // Watch URL changes (React updates ?variant=ID in URL on selection)
  var origPushState = history.pushState.bind(history);
  history.pushState = function () {
    origPushState.apply(history, arguments);
    checkVariant(getVariantIdFromUrl());
  };
  window.addEventListener('popstate', function () {
    checkVariant(getVariantIdFromUrl());
  });

  // Watch the hidden variant ID input inside the ATC form (React writes to this on variant select)
  function watchAtcFormInput(atcForm) {
    var idInput = atcForm.querySelector('input[name="id"]');
    if (!idInput) return;

    var lastValue = idInput.value;

    // MutationObserver for attribute changes
    var inputObserver = new MutationObserver(function () {
      if (idInput.value !== lastValue) {
        lastValue = idInput.value;
        checkVariant(idInput.value);
      }
    });
    inputObserver.observe(idInput, { attributes: true, attributeFilter: ['value'] });

    // Also poll since React may set value without triggering MutationObserver
    setInterval(function () {
      if (idInput.value !== lastValue) {
        lastValue = idInput.value;
        checkVariant(idInput.value);
      }
    }, 300);
  }

  // Initialise once React has rendered the ATC form and price into the DOM
  function init() {
    var atcForm = document.querySelector("form[action*='/cart/add']");
    var priceEl = document.querySelector('.product-price');
    if (!atcForm || !priceEl) return false;

    positionForm();
    watchAtcFormInput(atcForm);
    checkVariant(getVariantIdFromUrl());
    return true;
  }

  if (!init()) {
    var observer = new MutationObserver(function (_, obs) {
      if (init()) obs.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
